import { render, staticRenderFns } from "./ChangeTermType.vue?vue&type=template&id=a7b4ccb6"
import script from "./ChangeTermType.vue?vue&type=script&lang=js"
export * from "./ChangeTermType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports